<template>
  <div class="screensaver-list-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span>屏保管理</span>
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'screensaverCreate' })"
        >
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t("commonMsg.new") }}
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div class="list-container" v-bar>
        <div class="screensaver-handle">
          <div
            v-for="(item, idx) in screensaver"
            :key="idx"
            class="screensaver-item"
          >
            <div class="screensaver-cover">
              <img class="screensaver-img" :src="item.url" alt="" />
            </div>
            <div class="screensaver-info">
              <p class="screensaver-info-title">标题</p>
              <p>{{ item.title }}</p>
              <p class="screensaver-info-title">型号：</p>
              <p style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" :title="item.model.join('\\')" v-if="!(item.model.length===0||item.model.length===1&&item.model[0]==='')">{{ item.model.join("\\") }}</p>
              <p v-if="item.model.length===0||item.model.length===1&&item.model[0]===''">暂无</p>

              <p class="screensaver-info-title">语言：</p>
              <p style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" :title="item.lang.join('\\')" v-if="!(item.lang.length===0||item.lang.length===1&&item.lang[0]==='')">{{ item.lang.join("\\") }}</p>
              <p v-if="item.lang.length===0||item.lang.length===1&&item.lang[0]===''">暂无</p>

              <p class="screensaver-info-title">屏保型号：</p>
              <div class="screensaver-info-group" :title="item.modelGroupsStr" v-if="item.modelGroups.length"><span v-for="(item, index) in item.modelGroups" :key="index">{{item.name}}&nbsp;&nbsp;</span></div>
              <div v-if="!item.modelGroups.length">暂无</div>
            </div>
            <div class="screensaver-btn">
              <span
                class="edit-btn"
                @click="edit(item)"
              >编辑</span>
              <span
                class="del-btn"
                @click="remove(item)"
              >删除</span>
            </div>
          </div>
        </div>
      </div>
      <pagination
        :pageSize="listParams.limit"
        :total="count"
        @pageNum="getPageNum"
      />
    </el-card>
    <transition name="fade">
      <DelPopup @deleteHandle="deleteHandle" v-if="delPopup" />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import pagination from "@/components/pagination";
import DelPopup from "@/components/delPopup";
export default {
  components: {
    pagination,
    DelPopup
  },
  computed: {
    ...mapGetters(["delPopup"])
  },
  data() {
    return {
      screensaver: [],
      screensaverItem: null,
      count: 0,
      listParams: {
        page: 1,
        limit: 20
      }
    };
  },
  methods: {
    getScreenSavers() {
      this.$http.getScreenSavers(this.listParams).then(res => {
        this.screensaver = res.data.results;
        this.screensaver.map(item => {
          item['modelGroupsStr'] = ''
          item.modelGroups.map(subItem => {
            if (subItem.name) {
              item['modelGroupsStr']+=subItem.name
            }
          })
        })
        this.count = res.data.count;
      });
    },

    edit(item) {
      this.screensaverItem = item;
      this.$router.push({ name: "screensaverCreate", query: { id: item._id } });
    },

    remove(item) {
      this.screensaverItem = item;
      this.$store.commit("windowHandle", "delPopup");
    },
    deleteHandle() {
      this.$http.delScreenSavers(this.screensaverItem._id).then(res => {
        this.getScreenSavers();
      });
    },
    getPageNum(page) {
      this.listParams.page = page;
      this.getScreenSavers();
    }
  },
  mounted() {
    this.getScreenSavers();
  }
};
</script>

<style lang="scss" scoped>
.screensaver-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .left-part {
    flex: 1;
    display: flex;
    align-items: center;
    > span {
      margin-right: 10px;
      font-size: 16px;
    }
    .global-button-style {
      margin: 0;
    }
  }
  .list-container {
    flex: 1;
    display: flex;
    overflow: hidden;
    .screensaver-handle {
      flex: 1;
      padding-right: 5px !important;
      flex-direction: column;
      .screensaver-item {
        margin: 10px;
        background: #f7f7f7;
        overflow: hidden;
        width: calc(25% - 22px);
        float: left;
        border: 1px solid #ddd;
        .screensaver-cover {
          height: 300px;
          background-color: #fff;
          .screensaver-img {
            height: 300px;
            display: block;
            margin: 0 auto;
          }
        }
        .screensaver-info {
          margin: 0 8px;
          overflow: hidden;
          > .screensaver-info-title {
            font-weight: bold;
            font-size: 14px;
            margin-top: 15px;
          }
          .screensaver-info-group {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          > p {
            word-wrap: break-word;
            margin: 5px 0;
          }
          .grey {
            color: #fff;
            background-color: #828282;
            padding: 4px 8px;
            font-size: 14px;
            border-radius: 2px;
          }
          .green {
            color: #fff;
            background-color: #3a983a;
            padding: 4px 8px;
            font-size: 14px;
            border-radius: 2px;
          }
        }
        .screensaver-btn {
          margin-top: 15px;
          margin-bottom: 10px;
          > .screensaver-el-icon {
            cursor: pointer;
            margin-left: 15px;
            font-size: 20px;
            padding: 2px;
            &:hover {
              background-color: #b5b5b5;
            }
            &.on-publish {
              color: #41b883;
            }
            &.off-publish {
              color: #d83a00;
            }
            &.disable-publish {
              color: #565656;
              cursor: not-allowed;
              &:hover {
                background-color: #dadada;
              }
            }
            &.screensaver-del {
              color: #d83a00;
            }
          }
          > span {
            color: #fff;
            padding: 4px 12px;
            border-radius: 3px;
            margin: 0 5px;
            cursor: pointer;
            display: inline-block;
            &.edit-btn {
              background-color: #337ab7;
              &:hover {
                background-color: #3783c4;
              }
            }
            &.del-btn {
              background-color: #d9534f;
              &:hover {
                background-color: #ef6f6c;
              }
            }
          }
        }
      }
    }
  }
}
</style>
